import React from 'react';
import s from './spinner.module.scss';

const Spinner = () => {
  return <div className={s.spinner} />;
};

export default Spinner;
